import { useRouter } from 'vue-router';
import { useTrainingMatrixRevisionSelection } from './useTrainingMatrixRevisionSelection';

export function useTrainingMatrixReport() {
  const router = useRouter();
  const selection = useTrainingMatrixRevisionSelection();

  function confirmRevisionSelection(): void {
    const revisionId = selection.selectedRevisionId.value;
    if (revisionId === null) return;

    selection.closeModal();
    router.push({
      name: 'TreinamentosMatrizGerarMatriz',
      query: { revisionId: String(revisionId) },
    });
  }

  selection.fetchRevisions();

  return {
    isRevisionModalOpen: selection.isModalOpen,
    isLoadingRevisions: selection.loading,
    revisions: selection.revisions,
    selectedRevisionId: selection.selectedRevisionId,
    hasAnyRevision: selection.hasAnyRevision,
    openRevisionModal: selection.openModal,
    closeRevisionModal: selection.closeModal,
    selectRevision: selection.selectRevision,
    confirmRevisionSelection,
    refreshRevisionAvailability: selection.fetchRevisions,
  };
}
